import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', () => {
  //All refs become states
  const loadingStack = ref<boolean[]>([])

  //All computeds become getters
  const loading = computed(() => loadingStack.value.length > 0)

  //All functions become actions
  function initLoading() {
    loadingStack.value.push(true)
  }

  function removeLoading() {
    loadingStack.value.pop()
  }

  //Return public computeds, refs and functions
  return { initLoading, removeLoading, loading }
})
